export default class CoordinateUtils {
  static get6FractionDigitsString(number: number): string {
    return number.toFixed(6);
  }
}
